import {
    Button,
    Card,
    CardContent,
    Grid,
    TextField,
    Typography,
    Divider,
    Modal,
    Box,
    Autocomplete,
    Table,
} from "@mui/material";
import ArrowBackSharpIcon from "@mui/icons-material/ArrowBackSharp";
import React, { useEffect, useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import HOST_URL from "../../../utils/Url";
import { useFormik } from "formik";
import * as Yup from "yup";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";
import ToastApp from "../../../ToastApp";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import DeleteIcon from "@mui/icons-material/Delete";
import api from "../../../utils/Url";
import dayjs, { Dayjs } from "dayjs";
import EditIcon from '@mui/icons-material/Edit';

// import Autocomplete from "@mui/material/Autocomplete";
// import { Margin } from "@mui/icons-material";
// import nopdf from '../../../assets/images/nopdf.png'

// const style = {
//     position: "absolute" as "absolute",
//     top: "50%",
//     left: "50%",
//     transform: "translate(-50%, -50%)",
//     width: "180vh",
//     height: "85vh",
//     bgcolor: "#f5f5f5",
//     border: "1px solid #000",
//     boxShadow: 24,
//     p: 4,
//     borderRadius: 10,
// };



type Props = {};

const ReqFormAdd = (props: Props) => {


    const [Remark, setRemark] = useState("");

    const [ReqFileStatus, setReqFileStatus] = useState("");
    const [DateState, setDateState] = useState("");

    // const [RowTableData, setRowTableData] = useState<any>([]);
    const [enteredDepositAmount, setEnteredDepositAmount] = useState(0);
    const [tableData, setTableData] = useState<any>([]);
    const [editRowIndex, setEditRowIndex] = useState(null);



    const handleEditCell = (rowIndex: any, columnName: any, value: any) => {
        const updatedTableData = [...tableData];
        updatedTableData[rowIndex][columnName] = value;
        setTableData(updatedTableData);
    };

    // Define a function to toggle edit mode for a row
    const toggleEditMode = (rowIndex: any) => {
        setEditRowIndex(rowIndex === editRowIndex ? null : rowIndex);
    };








    const RemarkChangeHandler = (event: any) => {
        setRemark(event.target.value);
    };
    const ReqFileChangeHandler = (event: any) => {
        setReqFileStatus(event.target.value);
    };

    const DateChangeHandler = (event: any) => {
        // Convert the date to a valid string format (e.g., "YYYY-MM-DD")
        const formattedDate = new Date(event.target.value).toISOString().split('T')[0];
        setDateState(formattedDate);
    };




    const [CheckMode, setCheckMode] =
        React.useState<FilmOptionType | null>(null);
    const { i18n, t } = useTranslation();


    const [optionCheckMode, setOptionCheckMode] = useState([{ value: "-1", label: t("text.SelectChackNo") },]);

    const [StatusOption, setStatusOption] = useState([{ value: "-1", label: t("text.SelectStatus") },]);

    const [AplicationOption, setAplicationOption] = useState([{ value: "-1",label:t("text.ApplicationNo")},]);




    useEffect(() => {
        getCheckModeData();
        getStatus();
        getAplicationNo();

    }, [])

    const getCheckModeData = () => {
        const collectData = {
            fileID: -1,
            fileType: -1,
            fileGroup: -1,
            fileCategory: -1,
            fileClass: -1,
            fileSubject: -1,
        };

        api
            .post('FileDetail/GetFileDetails', collectData)
            .then((res) => {
                const arr = [];
                console.log("result" + JSON.stringify(res.data.data));
                for (let index = 0; index < res.data.data.length; index++) {
                    arr.push({
                        label: res.data.data[index]["chackNo"],
                        value: res.data.data[index]["fileID"],
                    });

                }
                setOptionCheckMode(arr);
            });
    };

    const getAplicationNo = () => {

        const collectData = {

        }

        api
            .get('CoustPropertyReqForm/GetMaxApplicationNo',collectData)
            .then((res) => {
                const arr = [];
                console.log("getAplication", JSON.stringify(res.data.data));
                for (let index = 0; index < res.data.data.length; index++) {
                    arr.push({
                        label: res.data.data[index]["applicationNo"],
                        value: res.data.data[index]["requestId"],
                    });

                }
                setAplicationOption(arr);
            });
    };



    const getStatus = () => {
        const collectData = {
            "receiptStatId": -1,
        };

        api
            .post('ReceiptStatus/GetReceiptStatus', collectData)
            .then((res) => {
                const arr = [];
                console.log("result" + JSON.stringify(res.data.data));
                for (let index = 0; index < res.data.data.length; index++) {
                    arr.push({
                        label: res.data.data[index]["recStatus"],
                        value: res.data.data[index]["receiptStatId"],
                    });

                }
                setStatusOption(arr);
            });
    };



    const addMoreRow = () => {

        const newRows = {
            id: tableData.length + 1,
            chackNo: CheckMode?.value.toString() || "",
            chackNos: CheckMode?.label || "",
            recDate: DateState || "",
            reqFileStatus: ReqFileStatus || "",
            remark: Remark || "",

            // createdDt: defaultValues,
            // modifyDt: defaultValues,
            // user_ID: 0,
            // advertisementEntryID: -1,0
        };

        console.log("table row", newRows)

        setTableData((prevTableData: any) => {
            const updatedTableDataed = [...prevTableData, newRows];
            onsumdatas(updatedTableDataed);
            return updatedTableDataed;
        });

        setCheckMode(null);
        setDateState("");
        setReqFileStatus("");
        setRemark("");

    };

    const onsumdatas = (updatedTableDataed: string | any[]) => {
        var totalpaidamount = 0;
        console.log(tableData);

        for (var i = 0; i < updatedTableDataed.length; i++) {
            console.log(updatedTableDataed[i]["paidAmount"]);
            totalpaidamount += Number(updatedTableDataed[i]?.paidAmount) || 0;
        }
        console.log("totalamount1", totalpaidamount);
        setEnteredDepositAmount(totalpaidamount);
    };


    const removeExtraRow = (id: any) => {
        setTableData((prevTableData: any) => {
            const updatedTableDataed = prevTableData.filter(
                (row: any) => row.id !== id
            );
            onsumdatas(updatedTableDataed);
            return updatedTableDataed;
        });
    };







    interface FilmOptionType {
        label: string;
        value: string;
    }

    let navigate = useNavigate();


    const [toaster, setToaster] = useState(false);





    const validationSchema = Yup.object({

        coustomerName: Yup.string().test(
            'required',
            t("text.reqCustomerName"),
            function (value: any) {
                return value && value.trim() !== '';
            }
        ),
    });

    const formik = useFormik({
        initialValues: {
            requestId: -1,
            coustomerName: "",
            reqDate: "",
            applicationNo: "",
            mobileNo: "",
            houseNo: "",
            address: "",
            status: "",
            coustomerReqFormTran: []
        },
        validationSchema: validationSchema,

        onSubmit: async (values) => {
            values.coustomerReqFormTran = tableData;

            console.log("Before submission formik values", values)
            // Handle form submission
            try {
                const response = await api.post(
                    `CoustPropertyReqForm/AddUpdateCoustPropertyReqForm`,
                    values
                );
                if (response.data.isSuccess) {
                    toast.success(response.data.mesg);
                    navigate('/Library/ReqForm');
                } else {
                    toast.error(response.data.mesg);
                }
            } catch (error) {
                console.error("Error:", error);
                toast.error("An error occurred. Please try again.");
            }
        },


    });

    const requiredFields = ['coustomerName'];

    const back = useNavigate();




    return (
        <div>
            <div
                style={{
                    padding: "-5px 5px",
                    backgroundColor: "#ffffff",
                    borderRadius: "5px",
                    border: ".5px solid #FF7722",
                    marginTop: "3vh"
                }}
            >
                <CardContent>
                    <Typography
                        variant="h5"
                        textAlign="center"
                        style={{ fontSize: "18px", fontWeight: 500 }}
                    >
                        {t("text.ReqFormAdd")}
                    </Typography>

                    <Grid item sm={4} xs={12}>
                        <Typography style={{ marginTop: "-75px" }}>
                            <Button
                                type="submit"
                                onClick={() => back(-1)}
                                variant="contained"
                                style={{
                                    marginBottom: 15,
                                    marginTop: "45px",
                                    backgroundColor: "blue",
                                    width: 20,
                                }}
                            >
                                <ArrowBackSharpIcon />
                            </Button>
                        </Typography>
                    </Grid>
                    <Divider />
                    <br />
                    <form onSubmit={formik.handleSubmit}>
                        {toaster === false ? "" : <ToastApp />}
                        <Grid item xs={12} container spacing={2}>

                            <Grid item lg={4} xs={12}>
                                <TextField
                                    id="applicationNo"
                                    name="applicationNo"
                                    label={t("text.ApplicationNo")}
                                    value={AplicationOption.length > 0 ? AplicationOption[0].label : ''}
                                    placeholder={t("text.ApplicationNo")}
                                    size="small"
                                    fullWidth
                                    style={{ backgroundColor: "white" }}
                                    InputProps={{
                                        readOnly: true,
                                    }}
                                />
                            </Grid>

                            <Grid item lg={4} xs={12}>
                                <TextField
                                    id="reqDate"
                                    name="reqDate"
                                    label={t("text.EnterReqDate")}
                                    value={formik.values.reqDate}
                                    placeholder={t("text.EnterReqDate")}
                                    InputLabelProps={{ shrink: true }}
                                    size="small"
                                    type="date"
                                    fullWidth
                                    style={{ backgroundColor: "white" }}
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                />
                            </Grid>


                            <Grid item lg={4} xs={12}>
                                <TextField
                                    id="coustomerName"
                                    name="coustomerName"
                                    label={
                                        <span>
                                            {t("text.EnterCustomerName")}{requiredFields.includes('coustomerName') && (
                                                <span style={{ color: formik.values.coustomerName ? 'green' : 'red' }}>*</span>
                                            )}
                                        </span>
                                    }
                                    value={formik.values.coustomerName}
                                    placeholder={t("text.EnterCustomerName")}
                                    size="small"
                                    fullWidth
                                    style={{
                                        backgroundColor: 'white',
                                        borderColor: formik.touched.coustomerName && formik.errors.coustomerName ? 'red' : 'initial',
                                    }}
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                />
                                {formik.touched.coustomerName && formik.errors.coustomerName ? (
                                    <div style={{ color: "red", margin: "5px" }}>{formik.errors.coustomerName}</div>
                                ) : null}
                            </Grid>

                            <Grid item lg={4} xs={12}>
                                <TextField
                                    id="mobileNo"
                                    name="mobileNo"
                                    label={t("text.MobileNO")}
                                    value={formik.values.mobileNo}
                                    placeholder={t("text.MobileNO")}
                                    size="small"
                                    fullWidth
                                    style={{ backgroundColor: "white" }}
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                />
                            </Grid>


                            <Grid item lg={4} xs={12}>
                                <TextField
                                    id="houseNo"
                                    name="houseNo"
                                    label={t("text.HouseNO")}
                                    value={formik.values.houseNo}
                                    placeholder={t("text.HouseNO")}
                                    size="small"
                                    fullWidth
                                    style={{ backgroundColor: "white" }}
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                />
                            </Grid>






                            <Grid item lg={4} xs={12}>
                                <TextField
                                    id="address"
                                    name="address"
                                    label={t("text.EnterAddress")}
                                    value={formik.values.address}
                                    placeholder={t("text.EnterAddress")}
                                    inputProps={{}}
                                    size="small"
                                    type="text"
                                    fullWidth
                                    style={{ backgroundColor: "white" }}
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                />
                            </Grid>



                            <Grid item lg={4} xs={12}>
                                <Autocomplete
                                    disablePortal
                                    id="combo-box-demo"
                                    options={StatusOption}
                                    // value={
                                    //   LocationOption.find(
                                    //         (option:any) => option.value === prevRecord[0]?.currentLocation) || null
                                    // }
                                    fullWidth
                                    size="small"
                                    onChange={(event, newValue: any) => {
                                        console.log(newValue?.value);
                                        formik.setFieldValue(
                                            "status",
                                            newValue?.value + ""
                                        );
                                        formik.setFieldTouched("status", true);
                                        formik.setFieldTouched("status", false);
                                    }}
                                    renderInput={(params) => (
                                        <TextField
                                            {...params}
                                            label={
                                                <span>
                                                    {t("text.SelectStatus")} {""}
                                                    {requiredFields.includes("status") && (
                                                        <span
                                                            style={{
                                                                color: formik.values.status
                                                                    ? "green"
                                                                    : "red",
                                                            }}
                                                        >
                                                            *
                                                        </span>
                                                    )}
                                                </span>
                                            }
                                        />
                                    )}
                                />

                            </Grid>

                        </Grid>

                        <br />
                        <Divider />
                        <br />

                        <Grid item xs={12} container spacing={2}>
                            <Grid xs={12} lg={3} item>
                                <Autocomplete
                                    disablePortal
                                    id="combo-box-demo"
                                    options={optionCheckMode}
                                    fullWidth
                                    value={CheckMode}
                                    size="small"
                                    onOpen={() => {
                                        getCheckModeData();
                                    }}
                                    onChange={(event: any, newValue) => {
                                        console.log(newValue);
                                        setCheckMode(newValue);
                                    }}
                                    style={{ backgroundColor: "white" }}
                                    renderInput={(params) => (
                                        <TextField
                                            {...params}
                                            label={t("text.SelectChackNo")}
                                        />
                                    )}
                                />
                            </Grid>

                            <Grid xs={12} lg={3} item>
                                <TextField
                                    type="date"
                                    // color="secondary"
                                    value={DateState}
                                    label={t("text.ReceiptDate")}
                                    InputLabelProps={{ shrink: true }}
                                    size="small"
                                    fullWidth
                                    // required
                                    style={{ backgroundColor: "white", marginBottom: "20px" }}
                                    onChange={DateChangeHandler}
                                />
                            </Grid>



                            <Grid xs={12} lg={2} item>
                                <TextField
                                    type="text"
                                    label={t("text.ReqFileStatus")}
                                    value={ReqFileStatus}
                                    placeholder={t("text.ReqFileStatus")}
                                    size="small"
                                    fullWidth
                                    // required
                                    style={{ backgroundColor: "white", marginBottom: "20px" }}
                                    onChange={ReqFileChangeHandler}
                                />
                            </Grid>

                            <Grid xs={12} lg={2} item>
                                <TextField
                                    type="text"
                                    label={t("text.Remark")}
                                    value={Remark}
                                    placeholder={t("text.Remark")}
                                    size="small"
                                    fullWidth
                                    // required
                                    style={{ backgroundColor: "white", marginBottom: "20px" }}
                                    onChange={RemarkChangeHandler}
                                />
                            </Grid>



                            <Grid xs={12} lg={2} item>
                                <Button
                                    startIcon={<AddCircleIcon />}
                                    variant="contained"
                                    style={{
                                        marginBottom: 15,
                                        backgroundColor: "info",
                                        width: "90%"
                                    }}
                                    onClick={addMoreRow}
                                // onChange={(event) => onValueUpdate(index, event)}
                                >
                                    {t("text.add")}{" "}
                                </Button>
                            </Grid>
                        </Grid>


                        <Grid container spacing={2}>
                            <Grid xs={12} sm={12} item>
                                <Table
                                    style={{
                                        borderCollapse: "collapse",
                                        width: "100%",
                                        border: "1px solid black",
                                    }}
                                >
                                    <thead
                                        style={{ backgroundColor: "#2196f3", color: "#f5f5f5" }}
                                    >
                                        <tr>
                                            <th
                                                style={{
                                                    borderLeft: "1px solid black",
                                                    paddingBlock: "10",
                                                    paddingTop: "5px",
                                                    paddingBottom: "5px",
                                                }}
                                            >
                                                {t("text.Action")}
                                            </th>
                                            <th
                                                style={{
                                                    borderLeft: "1px solid black",
                                                    paddingTop: "5px",
                                                    paddingBottom: "5px",
                                                }}
                                            >
                                               {t("text.ChakNo")}
                                            </th>

                                            <th
                                                style={{
                                                    borderLeft: "1px solid black",
                                                    paddingTop: "5px",
                                                    paddingBottom: "5px",
                                                }}
                                            >
                                                 {t("text.ReceiptDate")}
                                            </th>
                                            <th
                                                style={{
                                                    borderLeft: "1px solid black",
                                                    paddingTop: "5px",
                                                    paddingBottom: "5px",
                                                }}
                                            >
                                                 {t("text.ReqFileStatus")}
                                            </th>

                                            <th
                                                style={{
                                                    borderLeft: "1px solid black",
                                                    paddingTop: "5px",
                                                    paddingBottom: "5px",
                                                }}
                                            >
                                                {t("text.Remark")}
                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody style={{ border: "1px solid black" }}>
                                        {tableData?.map((row: any, rowIndex: any) => (
                                            <tr key={row.id} style={{ border: "1px solid black" }}>
                                                <td
                                                    style={{
                                                        borderLeft: "1px solid black",
                                                        borderTop: "1px solid black",
                                                        textAlign: "center",
                                                    }}
                                                >

                                                    <EditIcon
                                                        style={{
                                                            fontSize: "20px",
                                                            color: "blue",
                                                            cursor: "pointer"
                                                        }}
                                                        onClick={() => toggleEditMode(rowIndex)} // Define the edit functionality
                                                    />
                                                    <DeleteIcon
                                                        style={{
                                                            fontSize: "20px",
                                                            color: "darkred",
                                                            cursor: "pointer",
                                                        }}
                                                        onClick={() => removeExtraRow(row.id)}
                                                    />


                                                </td>
                                                <td
                                                    style={{
                                                        borderLeft: "1px solid black",
                                                        borderTop: "1px solid black",
                                                        textAlign: "center",
                                                    }}
                                                >
                                                    {editRowIndex === rowIndex ? (
                                                        <input
                                                            type="text"
                                                            value={row.chackNos}
                                                            onChange={(e) => handleEditCell(rowIndex, 'chackNos', e.target.value)}
                                                        />
                                                    ) : (
                                                        row.chackNos
                                                    )}
                                                </td>
                                                <td
                                                    style={{
                                                        borderLeft: "1px solid black",
                                                        borderTop: "1px solid black",
                                                        textAlign: "center",
                                                    }}

                                                >
                                                    {editRowIndex === rowIndex ? (
                                                        <input
                                                            type="text"
                                                            value={dayjs(row.recDate).format("YYYY-MM-DD")}
                                                            onChange={(e) => handleEditCell(rowIndex, 'recDate', e.target.value)}
                                                        />
                                                    ) : (
                                                        dayjs(row.recDate).format("YYYY-MM-DD")
                                                    )}
                                                </td>

                                                <td
                                                    style={{
                                                        borderLeft: "1px solid black",
                                                        borderTop: "1px solid black",
                                                        textAlign: "center",
                                                    }}
                                                    
                                                >

                                                    {editRowIndex === rowIndex ? (
                                                        <input
                                                            type="text"
                                                            value={row.reqFileStatus}
                                                            onChange={(e) => handleEditCell(rowIndex, 'reqFileStatus', e.target.value)}
                                                        />
                                                    ) : (
                                                        row.reqFileStatus
                                                    )}

                                                </td>


                                                <td
                                                    style={{
                                                        borderLeft: "1px solid black",
                                                        borderTop: "1px solid black",
                                                        textAlign: "center",
                                                    }}
                                                    
                                                >
                                                    {editRowIndex === rowIndex ? (
                                                        <input
                                                            type="text"
                                                            value={row.remark}
                                                            onChange={(e) => handleEditCell(rowIndex, 'remark', e.target.value)}
                                                        />
                                                    ) : (
                                                        row.remark
                                                    )}
                                                    
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </Table>
                            </Grid>
                        </Grid>

                        <br />
                        <Divider />
                        <br />






                        <Grid xs={12} item >
                            <div style={{ justifyContent: "space-between", flex: 2 }}>
                                <Button
                                    type="submit"
                                    fullWidth
                                    style={{
                                        backgroundColor: "#059669",
                                        width: "48%",
                                        color: "white",
                                        margin: "1%",
                                    }}

                                >
                                    {t("text.save")}
                                </Button>



                                <Button
                                    type="reset"
                                    fullWidth
                                    style={{
                                        backgroundColor: "#F43F5E",
                                        width: "48%",
                                        color: "white",
                                        margin: "1%",
                                    }}
                                    onClick={(e) => formik.resetForm()}
                                >
                                    {t("text.reset")}
                                </Button>
                            </div>

                        </Grid>

                    </form>

                </CardContent>
            </div>
        </div>
    );
};

export default ReqFormAdd;